import { OauthServiceType } from '@websky/graphql';
import { sessionStorageSet, SOCIAL_AUTH_REDIRECT_URL } from '../../cache';
import { socialAuthPath, vkPath, sberIdPath, tIdPath, alfaIdPath, facebookPath, googlePath } from '../../SocialAuthCallback/utils';
export const getBackRedirectUrl = (serviceType, socialAuthCallbackUrl) => {
    const basePath = getBasePathUrl(socialAuthCallbackUrl);
    switch (serviceType) {
        case OauthServiceType.TinkoffID:
            return `${basePath}${tIdPath}`;
        case OauthServiceType.SberID:
            return `${basePath}${sberIdPath}`;
        case OauthServiceType.Vkontakte:
            return `${basePath}${vkPath}`;
        case OauthServiceType.Facebook:
            return `${basePath}${facebookPath}`;
        case OauthServiceType.Google:
            return `${basePath}${googlePath}`;
        case OauthServiceType.AlfaID:
            return `${basePath}${alfaIdPath}`;
        default:
            return window.location.href;
    }
};
export const prevSocialAuthKeyFactory = (serviceType) => `${SOCIAL_AUTH_REDIRECT_URL}_${serviceType}`;
export const setSocialAuthRedirectUrl = (serviceType) => {
    sessionStorageSet(prevSocialAuthKeyFactory(serviceType), location.href);
};
export const getBasePathUrl = (socialAuthCallbackUrl) => socialAuthCallbackUrl !== null && socialAuthCallbackUrl !== void 0 ? socialAuthCallbackUrl : `${window.location.origin}${socialAuthPath}`;
